/**
 * Date helper class (included by the helper service)
 *
 */
export class DateHelper {

    /**
     * All date formats from PHP to JS/Moment
     *
     */
    protected dateFormats = {
        d: 'DD',
        D: 'ddd',
        j: 'D',
        l: 'dddd',
        N: 'E',
        S: function () {
            return '[' + this.format('Do').replace(/\d*/g, '') + ']';
        },
        w: 'd',
        z: function () {
            return this.format('DDD') - 1;
        },
        W: 'W',
        F: 'MMMM',
        m: 'MM',
        M: 'MMM',
        n: 'M',
        t: function () {
            return this.daysInMonth();
        },
        L: function () {
            return this.isLeapYear() ? 1 : 0;
        },
        o: 'GGGG',
        Y: 'YYYY',
        y: 'YY',
        a: 'a',
        A: 'A',
        B: function () {
            var thisUTC = this.clone().utc(),
                // Shamelessly stolen from http://javascript.about.com/library/blswatch.htm
                swatch  = ((thisUTC.hours() + 1) % 24) + (thisUTC.minutes() / 60) + (thisUTC.seconds() / 3600);
            return Math.floor(swatch * 1000 / 24);
        },
        g: 'h',
        G: 'H',
        h: 'hh',
        H: 'HH',
        i: 'mm',
        s: 'ss',
        u: '[u]', // not sure if moment has this
        e: '[e]', // moment does not have this
        I: function () {
            return this.isDST() ? 1 : 0;
        },
        O: 'ZZ',
        P: 'Z',
        T: '[T]', // deprecated in moment
        Z: function () {
            return parseInt(this.format('ZZ'), 10) * 36;
        },
        c: 'YYYY-MM-DD[T]HH:mm:ssZ',
        r: 'ddd, DD MMM YYYY HH:mm:ss ZZ',
        U: 'X'
    };

    /**
     * Regular expression that matches all special date format characters
     *
     * @type {RegExp}
     */
    protected formatExpression = /[dDjlNSwzWFmMntLoYyaABgGhHisueIOPTZcrU]/g;

    /**
     * Convert php date format to Moment format
     *
     * @param phpFormat
     */
    public phpToMomentFormat(phpFormat) {

        return phpFormat.replace(this.formatExpression, (phpStr) => {
            return typeof this.dateFormats[phpStr] === 'function' ? this.dateFormats[phpStr].call(this) : this.dateFormats[phpStr];
        });

    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/date.helper.ts